// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importar el menú de {{platform}}',
    copy: 'Copiar el menú de {{restaurant}}',
    data: 'Crear el menú que Amigo leyó',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Crear {{categories}} y {{dishes}}',
    from: {
      file: 'Amigo leyó esto de tu archivo',
      chat: 'Amigo leyó esto de nuestro chat',
    },
    summary: 'Crea {{categories}} y {{dishes}}. Comprueba cada plato con su precio en la lista de abajo.',
    price: 'Precio',
    tax_category: 'Categoría de impuestos',
    no_price: 'Aún sin precio',
    default_tax: 'Tu tipo estándar',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Creando {{categories}} y {{dishes}}…',
    done: 'El menú está creado: {{categories}}, {{dishes}} y {{option_groups}} están en el menú de {{restaurant}}',
    done_plain: 'El menú está creado',
  },
  waiting: 'Esperando aprobación',
  labels: {
    from: 'Desde',
    to: 'Hasta',
    menu: 'Menú',
    brings_over: 'Incluye',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'El menú que Amigo leyó · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, su única sede',
    brand_one: 'Menú de la marca {{name}}, su única sucursal',
    brand_other: 'Menú de la marca {{name}}, las {{count}} sedes',
  },
  menu: {
    empty: 'Vacío, así que este pasa a ser el menú',
    adds: 'Se añade al menú actual ({{size}}). Los platos con el mismo nombre se actualizan; no se elimina nada.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} categoría',
    categories_other: '{{count}} categorías',
    dishes_one: '{{count}} plato',
    dishes_other: '{{count}} platos',
    option_groups_one: '{{count}} grupo de opciones',
    option_groups_other: '{{count}} grupos de opciones',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Todo, tal cual',
    categories: 'categorías',
    dishes: 'platos',
    descriptions: 'descripciones',
    prices: 'precios',
    option_groups: 'grupos de opciones',
    photos: 'fotos',
    where: {
      allergens_nutrition: 'alérgenos y datos nutricionales donde {{platform}} los tiene',
      allergens: 'alérgenos donde {{platform}} los tiene',
      nutrition: 'datos nutricionales donde {{platform}} los tiene',
    },
  },
  not_live:
    '{{restaurant}} aún no está activo: los clientes pueden ver el menú en el enlace de la tienda, pero no pueden pedir.',
  buttons: {
    import: 'Importar',
    copy: 'Copiar',
    cancel: 'Cancelar',
  },
  hint: 'O responde abajo para cambiar algo.',
  action_failed: 'No se completó, así que no ha cambiado nada. Inténtalo de nuevo en un momento.',
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Esta importación ya se está ejecutando. Amigo te avisa aquí cuando termine.',
    already_applying: 'Se está aplicando ahora mismo. Espera un momento hasta que termine.',
  },
  importing: {
    title: {
      import: 'Importando desde {{platform}}…',
      copy: 'Copiando desde {{restaurant}}…',
    },
    started: 'Iniciado {{time}}',
    queued: 'Iniciando…',
    hint: 'Esto puede tardar unos minutos. Puedes cerrar el panel o seguir trabajando; publicaré el resultado aquí.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'La importación desde {{platform}} está lista: {{categories}}, {{dishes}} y {{option_groups}} están en el menú de {{restaurant}}',
      copy: 'La copia está lista: {{categories}}, {{dishes}} y {{option_groups}} están en el menú',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'La importación desde {{platform}} ha terminado',
      copy: 'La copia ha terminado',
    },
    finished: 'Finalizado {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Abrir {{page}}',
  },
  failed: {
    title: {
      import: 'No se pudo importar: {{reason}}',
      copy: 'No se pudo copiar: {{reason}}',
    },
    title_plain: {
      import: 'No se pudo importar',
      copy: 'No se pudo copiar',
    },
    nothing: {
      import: 'No se importó nada.',
      copy: 'No se copió nada.',
    },
    what_to_try: 'Qué probar:',
    retry: 'Intentar de nuevo',
    reasons: {
      listing_not_found: {
        title: 'anuncio no encontrado',
        text: '{{platform}} no tiene ningún restaurante en este enlace. No se importó nada.',
        try: 'Abre el enlace en un navegador para comprobar que muestra el menú del restaurante y vuelve a enviarlo.',
      },
      listing_not_supported: {
        title: 'anuncio no compatible',
        text: 'Esta es una página de cadena de {{platform}}, no el menú de un restaurante, así que no puedo importarla. No se importó nada.',
        try: 'Envía el enlace de la página de menú propia del restaurante en {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} falló',
        text: '{{platform}} no respondió, así que no se importó nada.',
        try: 'Inténtalo de nuevo en unos minutos.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'la copia falló',
        text: 'La copia no terminó, así que no se copió nada.',
        try: 'Inténtalo de nuevo en unos minutos.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'la moneda no coincide',
        text: 'El anuncio está en {{listing}}, pero {{restaurant}} usa {{currency}}. No se importó nada.',
        try: 'Envía un anuncio en {{currency}} o comprueba antes la moneda del restaurante en {{page}}.',
        text_other: 'El anuncio está en otra moneda distinta de la de {{restaurant}}. No se importó nada.',
        try_other: 'Envía un anuncio en la moneda del restaurante o comprueba antes su moneda en {{page}}.',
      },
      link_paused: {
        title: 'enlace en pausa',
        text: 'Este enlace falló 3 veces seguidas, por lo que las importaciones desde él están en pausa hasta {{time}}. No se importó nada.',
        text_no_until:
          'Este enlace falló 3 veces seguidas, por lo que las importaciones desde él están en pausa por ahora. No se importó nada.',
        try: 'Envía un enlace de otra plataforma o copia el menú de otro restaurante.',
      },
    },
  },
  stopped: {
    title: 'Detenido: {{restaurant}} se activó',
    nothing: {
      import: 'No se importó nada',
      copy: 'No se copió nada',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Cancelado',
    expired: 'Caducado',
    replaced: 'Reemplazado',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprobado.',
    cancelled: 'Cancelado.',
    retried: 'Se volvió a intentar.',
  },
};
